import { DEFAULT_THEME_ID } from './constants';
import classicGold from './classic-gold';
import customBlue from './custom-blue';
import selfBlue from './self-blue';
import customGold from './custom-gold';

/** 已注册主题表：theme slug → theme config */
const themeRegistry = {
  [classicGold.id]: classicGold,
  [customBlue.id]: customBlue,
  [selfBlue.id]: selfBlue,
  [customGold.id]: customGold,
};

/**
 * 后台 themeCode → 前端主题 slug 映射
 */
export const BACKEND_THEME_CODE_MAP = {
  X5mG9qL2: 'custom-blue',
  PJcYwEbN: 'self-blue',
  b96CAMpf: 'custom-gold',
  'custom-blue': 'custom-blue',
  'self-blue': 'self-blue',
  'custom-gold': 'custom-gold',
  'classic-gold': 'classic-gold',
};

/** @deprecated 使用 BACKEND_THEME_CODE_MAP */
export const BACKEND_THEME_ID_MAP = BACKEND_THEME_CODE_MAP;

function resolveThemeSlug(themeCode) {
  if (themeCode == null || themeCode === '') {
    return DEFAULT_THEME_ID;
  }
  const key = themeCode;
  return (
    BACKEND_THEME_CODE_MAP[key] ||
    BACKEND_THEME_CODE_MAP[String(key)] ||
    String(key)
  );
}

/**
 * 根据 themeCode 获取主题配置，未知编码回退默认主题
 * @param {string} themeCode
 */
export function getTheme(themeCode) {
  const slug = resolveThemeSlug(themeCode);
  return themeRegistry[slug] || themeRegistry[DEFAULT_THEME_ID];
}

/**
 * 注册新主题（供后续动态扩展）
 * @param {object} theme
 */
export function registerTheme(theme) {
  if (!theme?.id) {
    throw new Error('[theme] registerTheme: theme.id is required');
  }
  themeRegistry[theme.id] = theme;
}

export { DEFAULT_THEME_ID, classicGold, customBlue, selfBlue, customGold };
export default themeRegistry;
